module.exports = __webpack_public_path__ + "img/Eventbrite_Logo.28a8fd00.svg";